import { Route } from '@angular/router';
import { developmentGuard } from 'src/app/modules/development/guards/development.guard';
import { DC_ROUTING } from 'src/app/shared/routing.tokens';

export const smartDeviceRoutes: Route[] = [
    {
        path: DC_ROUTING.SMART_DEVICES,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./pages/smart-devices/smart-devices.component').then((c) => c.SmartDevicesComponent),
            },
            {
                path: 'invites',
                loadComponent: () =>
                    import('./pages/smart-device-invites/smart-device-invites.component').then(
                        (c) => c.SmartDeviceInvitesComponent
                    ),
            },
            {
                path: 'omni/:id/debug',
                canActivate: [developmentGuard],
                loadComponent: () =>
                    import('./omni/pages/omni-debug/omni-debug.component').then((c) => c.OmniDebugComponent),
            },
            {
                path: 'omni/:id',
                loadComponent: () => import('./omni/pages/omni/omni.component').then((c) => c.OmniComponent),
            },
            {
                path: 'virt/:id',
                loadComponent: () => import('./pages/smart-devices/virt/virt.component').then((c) => c.VirtComponent),
            },
        ],
    },
];
